import noop from 'lib/function/noop'
import { createContext, useContext } from 'react'
import type { ChatMapContextValue, ChatMapMarker } from './types'

const defaultValue: ChatMapContextValue = {
  activePlaceId: null,
  setActivePlaceId: noop,
  focusPlace: noop,
  markers: [],
}

export const ChatMapContext = createContext<ChatMapContextValue>(defaultValue)

export function useChatMapContext() {
  return useContext(ChatMapContext)
}

/** Find a marker by its stable `markerKey`. */
export function findMarkerByKey(
  markers: Array<ChatMapMarker>,
  markerKey: string,
): ChatMapMarker | undefined {
  return markers.find(marker => marker.markerKey === markerKey)
}

/** @deprecated Prefer `findMarkerByKey`. */
export const findMarkerByPlaceId = findMarkerByKey
